import React, { useEffect, useState } from 'react'
import { Table, Button, Modal, Input, Header, Form } from 'semantic-ui-react'
import { toast } from 'react-toastify'
import useAxios from '../../../lib/auth/useAxios'
import MickeyTable from '../../../components/MickeyTable/MickeyTable'
import env from '../../../env'
import SupplierQuotesRow from './SupplierQuotesRow'
import { useSelector } from 'react-redux'

function SupplierQuotes(props) {
  const { supplier, setCurrentTab } = props
  const tenant = useSelector((state) => {
    return state?.globals?.tenant
  })
  const axios = useAxios()
  const [rfqs, setRfqs] = useState([])
  const [loading, setLoading] = useState(true)
  const [submitModal, setSubmitModal] = useState(false)
  const [selectedRfq, setSelectedRfq] = useState(null)
  const [price, setPrice] = useState('')
  const [notes, setNotes] = useState('')
  const [file, setFile] = useState(null)

  const fetchRFQs = async () => {
    try {
      const response = await axios.get('/main/rfq-items/', {
        params: { active: true, status: 'pending', supplier_id: supplier?.id },
      })
      setRfqs(response.data.results)
      setLoading(false)
    } catch (error) {
      toast.error('Error fetching RFQs')
      setLoading(false)
    }
  }

  useEffect(() => {
    setCurrentTab('quotes')
    fetchRFQs()
  }, [])

  const handleSubmitQuote = async (rfq_item_id, price, quantity) => {
    if (!price || !quantity) {
      toast.error('Please enter a price and quantity')
      return
    }

    try {
      await axios.post(`/main/rfq-items/${rfq_item_id}/submit_quote/`, {
        price: price,
        quantity: quantity,
      })
      toast.success('Quote submitted successfully')
      setSubmitModal(false)
      setSelectedRfq(null)
      setPrice('')
      setNotes('')
      fetchRFQs()
    } catch (error) {
      toast.error('Error submitting quote')
    }
  }
  const handleUploadPriceSheet = async () => {
    if (!file) {
      toast.error('Please add a file.')
      return
    }

    try {
      await axios.post(`/main/rfqs/${selectedRfq.id}/upload_price_sheet/`, {
        file: file,
      })
      toast.success('Quote submitted successfully')
      setSubmitModal(false)
      setSelectedRfq(null)
      setPrice('')
      setNotes('')
      fetchRFQs()
    } catch (error) {
      toast.error('Error submitting quote')
    }
  }

  const handleQuoteClick = (rfq) => {
    setSelectedRfq(rfq)
    setSubmitModal(true)
  }

  return (
    <div style={{ padding: '20px' }}>
      <Header as="h2" style={{ padding: '20px 20px 0 20px' }}>
        Quote Requests
        {/* <Button */}
        {/*   primary */}
        {/*   onClick={() => { */}
        {/*     setSubmitModal(true) */}
        {/*   }} */}
        {/*   style={{ */}
        {/*     float: 'right', */}
        {/*     '--primaryColor': tenant?.deployment_primary_color, */}
        {/*     '--secondaryButtonColor': env.REACT_APP_SECONDARY_BUTTON_COLOR, */}
        {/*   }} */}
        {/* > */}
        {/*   Upload Price Sheet */}
        {/* </Button> */}
      </Header>
      <MickeyTable
        headerRow={[
          'RFQ Number',
          'Product',
          'Price',
          'Quantity',
          'Unit',
          'Actions',
        ]}
        loaded={!loading}
        data={rfqs}
        emptyIcon={'file'}
        emptyMessage={'Requests for Quote will populate here'}
        renderBodyRow={(rfq, index) => (
          <SupplierQuotesRow
            key={rfq.id}
            rfq={rfq}
            onSubmit={handleSubmitQuote}
          />
        )}
        style={{ marginTop: '5px', margin: '10px' }}
        sticky
      />

      <Modal
        open={submitModal}
        onClose={() => {
          setSubmitModal(false)
        }}
      >
        <Modal.Header>Upload Pricing Sheet</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Field>
              <label>Pricing Sheet</label>
              <Input
                placeholder={'Upload Pricing Sheet'}
                type={'file'}
                onChange={(e, d) => {
                  setFile(d)
                }}
              />
            </Form.Field>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setSubmitModal(false)}>Cancel</Button>
          <Button
            primary
            onClick={handleSubmitQuote}
            style={{
              '--primaryColor': tenant?.deployment_primary_color,
              '--secondaryButtonColor': env.REACT_APP_SECONDARY_BUTTON_COLOR,
            }}
          >
            Upload
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  )
}

export default SupplierQuotes
